export default "__VITE_ASSET__2fccc8b5__"